import {useQueries, useQuery, useSuspenseQuery} from '@tanstack/react-query';
import {EmployeeService, ProfilePage} from 'client';
import {getService} from 'utilities';
import {queryClient} from 'views/QueryClientWrapper';

export const useProfileSuspense = ({ldap}: {ldap: string}) => {
  const {data} = useSuspenseQuery({
    queryKey: ['profile', ldap],
    queryFn: () => {
      try {
        return getService(EmployeeService).getProfileApiV1PeopleUserIdGet(ldap);
      } catch {
        return {};
      }
    },
  });

  return data;
};

export const useProfile = ({
  ldap,
  throwOnError = true,
}: {
  ldap?: string;
  throwOnError?: boolean;
}) => {
  const {data, isLoading} = useQuery({
    queryKey: ['profile', ldap],
    queryFn: () => getService(EmployeeService).getProfileApiV1PeopleUserIdGet(ldap ?? ''),
    throwOnError,
    enabled: !!ldap,
  });

  return {data: data, isLoading};
};

export const useProfiles = ({
  ldaps,
  enabled,
  suspense = true,
}: {
  ldaps: string[];
  enabled: boolean;
  suspense?: boolean;
}) => {
  const dedupedLdaps = Array.from(new Set(ldaps.filter(Boolean)));

  const profiles = useQueries({
    queries: dedupedLdaps.map((ldap) => ({
      queryKey: ['profile', ldap],
      queryFn: () => getService(EmployeeService).getProfileApiV1PeopleUserIdGet(ldap),
      throwOnError: false,
      suspense: enabled && suspense,
      enabled,
    })),
  })
    .map(({data}) => {
      if (data) {
        queryClient.setQueryData(['profile', data.employee.user_id], data);
        queryClient.setQueryData(['profile', data.employee.ldap], data);
      }

      return data;
    })
    .filter(Boolean);

  return profiles as ProfilePage[];
};
